<ng-container *ngIf="mobileMode; else elseMobileMode"> </ng-container>
<ng-template #elseMobileMode>
  <mat-tab-group
    *ngIf="tabsSelected?.collection.length > 0; else noFactory"
    [selectedIndex]="tabSelected.value"
  >
    <mat-tab *ngFor="let tab of tabsSelected?.collection; let i = index">
      <ng-template mat-tab-label>
        <div>
          {{ tab?.name }}
        </div>
      </ng-template>
      <app-tab-content-last-stats-device
        (tabChangedEmitter)="changeTabName($event)"
        [tab]="tab"
        [selectedLanguage]="language"
      ></app-tab-content-last-stats-device>
    </mat-tab>
  </mat-tab-group>

  <ng-template #noFactory>
    <div class="container mtop15">
      <div class="text-center m0auto">
        <app-svg name="no-factory"></app-svg>
      </div>
      <div class="text-center warning-factories">
        <h3>{{ "WARNING_MESSAGES.NO_FACTORIES_SELECTED" | translate }}</h3>
        <p class="dib">
          {{ "WARNING_MESSAGES.CHOOSE_ICON_ADD_FACTORY" | translate }} &nbsp;
        </p>
        <div class="text-center dib">
          <app-svg style="fill: rgb(211, 208, 208)" name="factory"></app-svg>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
